//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex'
import parseContent from '@/tools/parse-content'
import { VideoView, ImageGroup, TextView, Gender, AliPlay } from '@/components'
import FeedContent from './feed-content'

import config from '@/config'
import api from '@/api'

export default {
  components: {
    VideoView,
    ImageGroup,
    TextView,
    Gender,
    FeedContent,
    AliPlay
  },
  props: {
    value: {}
  },
  data: () => ({
    list: [],
    follow: '关注',
    xing: [1, 2, 3, 4, 5],
    query: {
      type: undefined
    }
  }),
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      isLoggedin: 'isLoggedin'
    }),
    videoHeight () {
      return (this.$el.clientWidth - 30) * 9 / 16 + 2
    }
  },
  methods: {
    parseContent: parseContent, // 内容转换，如标签，连接等

    // 登录判断
    checkAuth () {
      if (!this.isLoggedin) {
        this.$router.push({name: 'user_login'})
        return false
      } else {
        return true
      }
    },

    onItemClick (e, item) {
      let tag = e.target.getAttribute('tag')
      console.log(tag, e)
      if (tag) {
        this.$router.push({name: 'feed_topic_redirect', params: {key: tag}})
      } else {
        this.$router.push({name: 'feed_detail', params: {id: item.id}})
      }
    },
    userLink (item) {
      this.$router.push({name: 'u_home', params: {u_id: item.author.id}})
    },
    campLink (item) {
      this.$router.push({name: 'camp_detail', params: {id: item.camp_detail.uuid}, query: {type: item.camp_detail.type}})
    },
    campBtn (item) {
      this.$router.push({name: 'camp_detail', params: {id: item}})
    },
    locationLink (item) {
      window.location.href = 'http://map.wanfangche.com/?lat=' + item.lat + '&lng=' + item.lon
    },
    goArticle (item) {
      // var url = ''
      if (window.location.href.indexOf('t.m') !== -1 || window.location.href.indexOf('localhost') !== -1) {
        window.location.href = 'https://apps.wanfangche.com/article?id=' + item.id
      } else {
        window.location.href = 'https://apps.21rv.com/article?id=' + item.id
      }
    },
    goTopic (name) {
      this.$router.push({name: 'feed_topic_redirect', params: {key: name}})
    },
    goCms (item) {
      if (window.location.href.indexOf('t.m') !== -1 || window.location.href.indexOf('localhost') !== -1) {
        window.location.href = 'https://apps.wanfangche.com/information?id=' + item.id
      } else {
        window.location.href = 'https://apps.21rv.com/information?id=' + item.id
      }
    },
    // 点赞
    thumbUp (item) {
      if (this.checkAuth()) {
        item.is_follow = item.is_follow ? 0 : 1
        this.axios.post(api.feed.like, {
          id: item.id
        })
        .then(response => {
          if (response.status === 200 && response.data.code === 1) {
            response.data.data === -1 ? item.credit_num -= 1 : item.credit_num += 1
          }
        })
      }
    },

    // 关注用户
    doFollow (item) {
      if (this.checkAuth()) {
        // item.author.is_follow = (item.author.is_follow !== 1) ? 1 : 0
        if (item.author.is_follow === 0) {
          item.author.is_follow = 2
          for (let i = 0; i < this.list.length; i++) {
            if (item.author.id === this.list[i].author.id) {
              this.list[i].author.is_follow = 2
            }
          }
        } else {
          item.author.is_follow = 0
          for (let i = 0; i < this.list.length; i++) {
            if (item.author.id === this.list[i].author.id) {
              this.list[i].author.is_follow = 0
            }
          }
        }
        this.axios.post(api.feed.follow, {
          uid: this.currentUser.user_id,
          id: item.author.id,
          accesstoken: ''
        })
        .then(response => {
        })
      }
    },

    doDelete (item, index) {
      let r = confirm('确定删除？')
      if (r) {
        this.list.splice(index, 1)
        if (item.author && parseInt(item.author.id) === parseInt(this.currentUser.user_id)) {
          this.axios.post(api.feed.delete, {id: item.id})
        }
      }
    },

    // 微信相册
    albumView (src, list) {
      if (window.WeixinJSBridge) {
        window.WeixinJSBridge.invoke('imagePreview', {
          'urls': list.map(src => {
            return src + config.ossimage.xlarge
          }),
          'current': src + config.ossimage.xlarge
        })
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.query = this.$route.query
      this.list = this.value
    })
  },
  watch: {
    value (val) {
      this.list = val
      this.list.map((val) => {
        if (val.img.length > 3) {
          val.imgs = val.img.slice(0, 3)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/feed/list-item.vue